import { ColumnDef } from "@tanstack/react-table";
import type { EnrichedIcmStatement, IcmPayoutBreakdownItem } from "@/icm/types";
import { formatValueByDisplayType } from "@/icm/utils";

const BreakdownCol = ({
  key,
  label,
}: Pick<IcmPayoutBreakdownItem, "key" | "label">): ColumnDef<
  EnrichedIcmStatement,
  unknown
> => ({
  id: `breakdown_${key}`,
  header: label,
  meta: { size: "130px" },
  cell: ({ row }) => {
    const item = row.original.payout_breakdown_items.find(
      (breakdownItem) => breakdownItem.key === key,
    );

    if (!item) return "-";

    return formatValueByDisplayType(item.value, item.displayType);
  },
});

export default BreakdownCol;
